import { AnimatedSprite } from "appworks/graphics/animation/animated-sprite";
import { ButtonElement } from "appworks/graphics/elements/button-element";
import { SmartShape } from "appworks/graphics/elements/smart-shape";
import { ToggleElement } from "appworks/graphics/elements/toggle-element";
import { Layers } from "appworks/graphics/layers/layers";
import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { SoundNames } from "sounds-enum";

class GameLayers {
    public CelebrationForeground: Layers & {
        elements: {
            supermegawin: {
                positions: {};
            };
            active: {
                positions: {};
            };
            megawin: {
                positions: {};
            };
            bigwin: {
                positions: {};
            };
            totalwin: {
                positions: {};
            };
        };
    };
    public CelebrationContent: Layers & {
        elements: {
            celebration_1: {
                anim?: SpineContainer
                value?: Text
                positions: {};
            };
            active: {
                positions: {};
                anim?: SpineContainer
                value?: Text
            };
            celebration_2: {
                anim?: SpineContainer
                value?: Text
                positions: {};
            };
            celebration_3: {
                anim?: SpineContainer
                value?: Text
                positions: {};
            };
            celebration_4: {
                anim?: SpineContainer
                value?: Text
                positions: {};
            };
            celebration_5: {
                anim?: SpineContainer
                value?: Text
                positions: {};
            };
            totalwin: {
                value?: Text
                positions: {};
            };
            line_win_row_1: {
                value?: Text
                positions: {};
            };
            line_win_row_2: {
                value?: Text
                positions: {};
            };
            line_win_row_3: {
                value?: Text
                positions: {};
            };
            line_win_row_4: {
                value?: Text
                positions: {};
            };
        };
    };
    public CelebrationBackground: Layers & {
        elements: {
            supermegawin: {
                positions: {};
            };
            active: {
                positions: {};
            };
            megawin: {
                positions: {};
            };
            bigwin: {
                positions: {};
            };
            totalwin: {
                positions: {};
            };
        };
    };
    public Templates: Layers & {
        elements: {
            default: {
                quickhit_text?: Text
                positions: {};
            };
            active: {
                positions: {};
                quickhit_text?: Text
            };
        };
    };
    public JackpotValues: Layers & {
        elements: {
            default: {
                mini?: Text
                minor?: Text
                major?: Text
                grand?: Text
                positions: {};
            };
            active: {
                positions: {};
                mini?: Text
                minor?: Text
                major?: Text
                grand?: Text
            };
        };
    };
    public TigerHeader: Layers & {
        elements: {
            default: {
                logo?: Sprite
                positions: {};
            };
            active: {
                positions: {};
                logo?: Sprite
            };
        };
    };
    public InstantWins: Layers & {
        elements: {
            default: {
                positions: {};
            };
            active: {
                positions: {
                    pos_top_0?: DualPosition
                    pos_top_1?: DualPosition
                    pos_top_2?: DualPosition
                    pos_mid_0?: DualPosition
                    pos_mid_1?: DualPosition
                    pos_mid_2?: DualPosition
                    pos_rgt_0?: DualPosition
                    pos_rgt_1?: DualPosition
                    pos_rgt_2?: DualPosition
                    pos_0_0?: DualPosition
                    pos_0_1?: DualPosition
                    pos_0_2?: DualPosition
                    pos_0_3?: DualPosition
                    pos_1_0?: DualPosition
                    pos_1_1?: DualPosition
                    pos_1_2?: DualPosition
                    pos_1_3?: DualPosition
                    pos_2_0?: DualPosition
                    pos_2_1?: DualPosition
                    pos_2_2?: DualPosition
                    pos_2_3?: DualPosition
                    pos_3_0?: DualPosition
                    pos_3_1?: DualPosition
                    pos_3_2?: DualPosition
                    pos_3_3?: DualPosition
                    pos_4_0?: DualPosition
                    pos_4_1?: DualPosition
                    pos_4_2?: DualPosition
                    pos_4_3?: DualPosition
                };
                fs_info_panel?: Sprite
                bg_info_panel?: Sprite
                value?: Text
            };
            instant_win: {
                fs_info_panel?: Sprite
                bg_info_panel?: Sprite
                value?: Text
                positions: {
                    pos_top_0?: DualPosition
                    pos_top_1?: DualPosition
                    pos_top_2?: DualPosition
                    pos_mid_0?: DualPosition
                    pos_mid_1?: DualPosition
                    pos_mid_2?: DualPosition
                    pos_rgt_0?: DualPosition
                    pos_rgt_1?: DualPosition
                    pos_rgt_2?: DualPosition
                    pos_0_0?: DualPosition
                    pos_0_1?: DualPosition
                    pos_0_2?: DualPosition
                    pos_0_3?: DualPosition
                    pos_1_0?: DualPosition
                    pos_1_1?: DualPosition
                    pos_1_2?: DualPosition
                    pos_1_3?: DualPosition
                    pos_2_0?: DualPosition
                    pos_2_1?: DualPosition
                    pos_2_2?: DualPosition
                    pos_2_3?: DualPosition
                    pos_3_0?: DualPosition
                    pos_3_1?: DualPosition
                    pos_3_2?: DualPosition
                    pos_3_3?: DualPosition
                    pos_4_0?: DualPosition
                    pos_4_1?: DualPosition
                    pos_4_2?: DualPosition
                    pos_4_3?: DualPosition
                };
            };
        };
    };
    public Paylines: Layers & {
        elements: {
            default: {
                positions: {};
            };
            active: {
                positions: {};
            };
        };
    };
    public Footer: Layers & {
        elements: {
            default: {
                positions: {};
            };
            active: {
                positions: {};
            };
        };
    };
    public Anticipation: Layers & {
        elements: {
            default: {
                positions: {};
            };
            active: {
                positions: {};
                anticipation_3?: AnimatedSprite
                anticipation_4?: AnimatedSprite
            };
            s: {
                anticipation_3?: AnimatedSprite
                anticipation_4?: AnimatedSprite
                positions: {};
            };
            qh: {
                anticipation_4?: AnimatedSprite
                positions: {};
            };
        };
    };
    public MatrixForeground: Layers & {
        elements: {
            default: {
                bg_jp_3_4?: Sprite
                bg_jp_1_2?: Sprite
                fs_jp_3_4?: Sprite
                fs_jp_1_2?: Sprite
                bg_frame?: Sprite
                fs_frame?: Sprite
                reel_darken?: SmartShape
                fs_mini?: Text
                fs_minor?: Text
                fs_major?: Text
                fs_grand?: Text
                bg_mini?: Text
                bg_minor?: Text
                bg_major?: Text
                bg_grand?: Text
                positions: {};
            };
            active: {
                positions: {};
                bg_jp_3_4?: Sprite
                bg_jp_1_2?: Sprite
                fs_jp_3_4?: Sprite
                fs_jp_1_2?: Sprite
                bg_frame?: Sprite
                fs_frame?: Sprite
                reel_darken?: SmartShape
                fs_mini?: Text
                fs_minor?: Text
                fs_major?: Text
                fs_grand?: Text
                bg_mini?: Text
                bg_minor?: Text
                bg_major?: Text
                bg_grand?: Text
            };
        };
    };
    public ReelDust: Layers & {
        elements: {
            default: {
                dust_0?: AnimatedSprite
                dust_1?: AnimatedSprite
                dust_2?: AnimatedSprite
                dust_3?: AnimatedSprite
                dust_4?: AnimatedSprite
                positions: {};
            };
            active: {
                positions: {};
                dust_0?: AnimatedSprite
                dust_1?: AnimatedSprite
                dust_2?: AnimatedSprite
                dust_3?: AnimatedSprite
                dust_4?: AnimatedSprite
            };
        };
    };
    public FreespinsIntro: Layers & {
        elements: {
            default: {
                highlight_0?: Sprite
                highlight_1?: Sprite
                highlight_2?: Sprite
                highlight_3?: Sprite
                highlight_4?: Sprite
                positions: {
                    start_0_0?: DualPosition
                    start_0_1?: DualPosition
                    start_1_0?: DualPosition
                    start_1_1?: DualPosition
                    start_1_2?: DualPosition
                    start_2_0?: DualPosition
                    start_2_1?: DualPosition
                    start_3_0?: DualPosition
                    start_3_1?: DualPosition
                    start_4_0?: DualPosition
                    start_4_1?: DualPosition
                    start_4_2?: DualPosition
                    pause_start_0_0?: DualPosition
                    pause_start_0_1?: DualPosition
                    pause_start_1_0?: DualPosition
                    pause_start_1_1?: DualPosition
                    pause_start_1_2?: DualPosition
                    pause_start_2_0?: DualPosition
                    pause_start_2_1?: DualPosition
                    pause_start_3_0?: DualPosition
                    pause_start_3_1?: DualPosition
                    pause_start_4_0?: DualPosition
                    pause_start_4_1?: DualPosition
                    pause_start_4_2?: DualPosition
                    pause_end_0_0?: DualPosition
                    pause_end_0_1?: DualPosition
                    pause_end_1_0?: DualPosition
                    pause_end_1_1?: DualPosition
                    pause_end_1_2?: DualPosition
                    pause_end_2_0?: DualPosition
                    pause_end_2_1?: DualPosition
                    pause_end_3_0?: DualPosition
                    pause_end_3_1?: DualPosition
                    pause_end_4_0?: DualPosition
                    pause_end_4_1?: DualPosition
                    pause_end_4_2?: DualPosition
                    end_0_0?: DualPosition
                    end_0_1?: DualPosition
                    end_1_0?: DualPosition
                    end_1_1?: DualPosition
                    end_1_2?: DualPosition
                    end_2_0?: DualPosition
                    end_2_1?: DualPosition
                    end_3_0?: DualPosition
                    end_3_1?: DualPosition
                    end_4_0?: DualPosition
                    end_4_1?: DualPosition
                    end_4_2?: DualPosition
                    reel_darken?: DualPosition
                };
            };
            active: {
                positions: {
                    start_0_0?: DualPosition
                    start_0_1?: DualPosition
                    start_1_0?: DualPosition
                    start_1_1?: DualPosition
                    start_1_2?: DualPosition
                    start_2_0?: DualPosition
                    start_2_1?: DualPosition
                    start_3_0?: DualPosition
                    start_3_1?: DualPosition
                    start_4_0?: DualPosition
                    start_4_1?: DualPosition
                    start_4_2?: DualPosition
                    pause_start_0_0?: DualPosition
                    pause_start_0_1?: DualPosition
                    pause_start_1_0?: DualPosition
                    pause_start_1_1?: DualPosition
                    pause_start_1_2?: DualPosition
                    pause_start_2_0?: DualPosition
                    pause_start_2_1?: DualPosition
                    pause_start_3_0?: DualPosition
                    pause_start_3_1?: DualPosition
                    pause_start_4_0?: DualPosition
                    pause_start_4_1?: DualPosition
                    pause_start_4_2?: DualPosition
                    pause_end_0_0?: DualPosition
                    pause_end_0_1?: DualPosition
                    pause_end_1_0?: DualPosition
                    pause_end_1_1?: DualPosition
                    pause_end_1_2?: DualPosition
                    pause_end_2_0?: DualPosition
                    pause_end_2_1?: DualPosition
                    pause_end_3_0?: DualPosition
                    pause_end_3_1?: DualPosition
                    pause_end_4_0?: DualPosition
                    pause_end_4_1?: DualPosition
                    pause_end_4_2?: DualPosition
                    end_0_0?: DualPosition
                    end_0_1?: DualPosition
                    end_1_0?: DualPosition
                    end_1_1?: DualPosition
                    end_1_2?: DualPosition
                    end_2_0?: DualPosition
                    end_2_1?: DualPosition
                    end_3_0?: DualPosition
                    end_3_1?: DualPosition
                    end_4_0?: DualPosition
                    end_4_1?: DualPosition
                    end_4_2?: DualPosition
                    reel_darken?: DualPosition
                };
                highlight_0?: Sprite
                highlight_1?: Sprite
                highlight_2?: Sprite
                highlight_3?: Sprite
                highlight_4?: Sprite
            };
        };
    };
    public SymbolAnimations: Layers & {
        elements: {
            default: {
                positions: {};
            };
            active: {
                positions: {};
            };
        };
    };
    public MatrixContent: Layers & {
        elements: {
            other: {
                positions: {};
            };
            active: {
                positions: {
                    W_win?: DualPosition
                    W?: DualPosition
                    S_win?: DualPosition
                    S?: DualPosition
                    QH_win?: DualPosition
                    QHjGRAND?: DualPosition
                    QHjMAJOR?: DualPosition
                    QHjMINOR?: DualPosition
                    QHjMINI?: DualPosition
                    QH?: DualPosition
                    C_win?: DualPosition
                    C?: DualPosition
                    H1FS_14_win?: DualPosition
                    H1FS_14?: DualPosition
                    H1FS_13_win?: DualPosition
                    H1FS_13?: DualPosition
                    H1FS_12_win?: DualPosition
                    H1FS_12?: DualPosition
                    H1FS_win?: DualPosition
                    H1FS?: DualPosition
                    H1_14_win?: DualPosition
                    H1_14?: DualPosition
                    H1_13_win?: DualPosition
                    H1_13?: DualPosition
                    H1_12_win?: DualPosition
                    H1_12?: DualPosition
                    H1_win?: DualPosition
                    H1?: DualPosition
                    H2_win?: DualPosition
                    H2?: DualPosition
                    H3_win?: DualPosition
                    H3?: DualPosition
                    H4_win?: DualPosition
                    H4?: DualPosition
                    H5_win?: DualPosition
                    H5?: DualPosition
                    L1_win?: DualPosition
                    L1?: DualPosition
                    L2_win?: DualPosition
                    L2?: DualPosition
                    L3_win?: DualPosition
                    L3?: DualPosition
                    L4_win?: DualPosition
                    L4?: DualPosition
                    L5_win?: DualPosition
                    L5?: DualPosition
                    static?: DualPosition
                    symbol_x_y?: DualPosition
                    symbol_0_0?: DualPosition
                    symbol_0_1?: DualPosition
                    symbol_0_2?: DualPosition
                    symbol_0_3?: DualPosition
                    symbol_1_0?: DualPosition
                    symbol_1_1?: DualPosition
                    symbol_1_2?: DualPosition
                    symbol_1_3?: DualPosition
                    symbol_2_0?: DualPosition
                    symbol_2_1?: DualPosition
                    symbol_2_2?: DualPosition
                    symbol_2_3?: DualPosition
                    symbol_3_0?: DualPosition
                    symbol_3_1?: DualPosition
                    symbol_3_2?: DualPosition
                    symbol_3_3?: DualPosition
                    symbol_4_0?: DualPosition
                    symbol_4_1?: DualPosition
                    symbol_4_2?: DualPosition
                    symbol_4_3?: DualPosition
                };
            };
            default: {
                positions: {
                    W_win?: DualPosition
                    W?: DualPosition
                    S_win?: DualPosition
                    S?: DualPosition
                    QH_win?: DualPosition
                    QHjGRAND?: DualPosition
                    QHjMAJOR?: DualPosition
                    QHjMINOR?: DualPosition
                    QHjMINI?: DualPosition
                    QH?: DualPosition
                    C_win?: DualPosition
                    C?: DualPosition
                    H1FS_14_win?: DualPosition
                    H1FS_14?: DualPosition
                    H1FS_13_win?: DualPosition
                    H1FS_13?: DualPosition
                    H1FS_12_win?: DualPosition
                    H1FS_12?: DualPosition
                    H1FS_win?: DualPosition
                    H1FS?: DualPosition
                    H1_14_win?: DualPosition
                    H1_14?: DualPosition
                    H1_13_win?: DualPosition
                    H1_13?: DualPosition
                    H1_12_win?: DualPosition
                    H1_12?: DualPosition
                    H1_win?: DualPosition
                    H1?: DualPosition
                    H2_win?: DualPosition
                    H2?: DualPosition
                    H3_win?: DualPosition
                    H3?: DualPosition
                    H4_win?: DualPosition
                    H4?: DualPosition
                    H5_win?: DualPosition
                    H5?: DualPosition
                    L1_win?: DualPosition
                    L1?: DualPosition
                    L2_win?: DualPosition
                    L2?: DualPosition
                    L3_win?: DualPosition
                    L3?: DualPosition
                    L4_win?: DualPosition
                    L4?: DualPosition
                    L5_win?: DualPosition
                    L5?: DualPosition
                    static?: DualPosition
                    symbol_x_y?: DualPosition
                    symbol_0_0?: DualPosition
                    symbol_0_1?: DualPosition
                    symbol_0_2?: DualPosition
                    symbol_0_3?: DualPosition
                    symbol_1_0?: DualPosition
                    symbol_1_1?: DualPosition
                    symbol_1_2?: DualPosition
                    symbol_1_3?: DualPosition
                    symbol_2_0?: DualPosition
                    symbol_2_1?: DualPosition
                    symbol_2_2?: DualPosition
                    symbol_2_3?: DualPosition
                    symbol_3_0?: DualPosition
                    symbol_3_1?: DualPosition
                    symbol_3_2?: DualPosition
                    symbol_3_3?: DualPosition
                    symbol_4_0?: DualPosition
                    symbol_4_1?: DualPosition
                    symbol_4_2?: DualPosition
                    symbol_4_3?: DualPosition
                };
            };
        };
    };
    public MatrixBackground: Layers & {
        elements: {
            default: {
                reels?: Sprite
                positions: {};
            };
            active: {
                positions: {};
                reels?: Sprite
            };
        };
    };
    public Background: Layers & {
        elements: {
            default: {
                fireflies?: Sprite
                fs_spine?: SpineContainer
                bg_spine?: SpineContainer
                positions: {};
            };
            active: {
                positions: {};
                fireflies?: Sprite
                fs_spine?: SpineContainer
                bg_spine?: SpineContainer
            };
        };
    };
    public History: Layers & {
        elements: {
            replay: {
                bg?: SmartShape
                final_value?: Text
                final_lbl?: Text
                win_value?: Text
                win_lbl?: Text
                initial_value?: Text
                initial_lbl?: Text
                bet_value?: Text
                bet_lbl?: Text
                session_value?: Text
                session_lbl?: Text
                time_value?: Text
                time_lbl?: Text
                title?: Text
                positions: {};
            };
            active: {
                positions: {};
                bg?: SmartShape
                final_value?: Text
                final_lbl?: Text
                win_value?: Text
                win_lbl?: Text
                initial_value?: Text
                initial_lbl?: Text
                bet_value?: Text
                bet_lbl?: Text
                session_value?: Text
                session_lbl?: Text
                time_value?: Text
                time_lbl?: Text
                title?: Text
            };
        };
    };
    public PaytableContent: Layers & {
        elements: {
            page_1: {
                pip?: Sprite
                H1_4?: Sprite
                H1?: Sprite
                lining_1?: Sprite
                H1_numbers?: Sprite
                H2?: Sprite
                lining_2?: Sprite
                H2_numbers?: Sprite
                H3?: Sprite
                lining_3?: Sprite
                H3_numbers?: Sprite
                H4?: Sprite
                lining_4?: Sprite
                H4_numbers?: Sprite
                H5?: Sprite
                lining_5?: Sprite
                H5_numbers?: Sprite
                title?: Text
                text?: Text
                payouts_H1_5?: Text
                payouts_H1_4?: Text
                payouts_H1_3?: Text
                payouts_H1_2?: Text
                payouts_H2_5?: Text
                payouts_H2_4?: Text
                payouts_H2_3?: Text
                payouts_H3_5?: Text
                payouts_H3_4?: Text
                payouts_H3_3?: Text
                payouts_H4_5?: Text
                payouts_H4_4?: Text
                payouts_H4_3?: Text
                payouts_H5_5?: Text
                payouts_H5_4?: Text
                payouts_H5_3?: Text
                positions: {};
            };
            active: {
                positions: {};
                pip?: Sprite
                H1_4?: Sprite
                H1?: Sprite
                lining_1?: Sprite
                H1_numbers?: Sprite
                H2?: Sprite
                lining_2?: Sprite
                H2_numbers?: Sprite
                H3?: Sprite
                lining_3?: Sprite
                H3_numbers?: Sprite
                H4?: Sprite
                lining_4?: Sprite
                H4_numbers?: Sprite
                H5?: Sprite
                lining_5?: Sprite
                H5_numbers?: Sprite
                title?: Text
                text?: Text
                payouts_H1_5?: Text
                payouts_H1_4?: Text
                payouts_H1_3?: Text
                payouts_H1_2?: Text
                payouts_H2_5?: Text
                payouts_H2_4?: Text
                payouts_H2_3?: Text
                payouts_H3_5?: Text
                payouts_H3_4?: Text
                payouts_H3_3?: Text
                payouts_H4_5?: Text
                payouts_H4_4?: Text
                payouts_H4_3?: Text
                payouts_H5_5?: Text
                payouts_H5_4?: Text
                payouts_H5_3?: Text
                L1?: Sprite
                L1_numbers?: Sprite
                L2?: Sprite
                L2_numbers?: Sprite
                L3?: Sprite
                L3_numbers?: Sprite
                L4?: Sprite
                L4_numbers?: Sprite
                L5?: Sprite
                L5_numbers?: Sprite
                payouts_L1_5?: Text
                payouts_L1_4?: Text
                payouts_L1_3?: Text
                payouts_L2_5?: Text
                payouts_L2_4?: Text
                payouts_L2_3?: Text
                payouts_L3_5?: Text
                payouts_L3_4?: Text
                payouts_L3_3?: Text
                payouts_L4_5?: Text
                payouts_L4_4?: Text
                payouts_L4_3?: Text
                payouts_L5_5?: Text
                payouts_L5_4?: Text
                payouts_L5_3?: Text
                W?: Sprite
                wild_lining?: Sprite
                S?: Sprite
                scatter_lining?: Sprite
                QH?: Sprite
                qh_lining?: Sprite
                C?: Sprite
                c_lining?: Sprite
                title_2?: Text
                wild_text?: Text
                scatter_text?: Text
                qh_text?: Text
                c_text?: Text
                mini?: Sprite
                minor?: Sprite
                major?: Sprite
                grand?: Sprite
                money_collect_feature?: Text
                win_up_to?: Text
                multipliers?: Text
                multipliers_2?: Text
                mini_value?: Text
                minor_value?: Text
                major_value?: Text
                grand_value?: Text
                paylines?: Sprite
            };
            page_2: {
                pip?: Sprite
                L1?: Sprite
                lining_1?: Sprite
                L1_numbers?: Sprite
                L2?: Sprite
                lining_2?: Sprite
                L2_numbers?: Sprite
                L3?: Sprite
                lining_3?: Sprite
                L3_numbers?: Sprite
                L4?: Sprite
                lining_4?: Sprite
                L4_numbers?: Sprite
                L5?: Sprite
                lining_5?: Sprite
                L5_numbers?: Sprite
                title?: Text
                text?: Text
                payouts_L1_5?: Text
                payouts_L1_4?: Text
                payouts_L1_3?: Text
                payouts_L2_5?: Text
                payouts_L2_4?: Text
                payouts_L2_3?: Text
                payouts_L3_5?: Text
                payouts_L3_4?: Text
                payouts_L3_3?: Text
                payouts_L4_5?: Text
                payouts_L4_4?: Text
                payouts_L4_3?: Text
                payouts_L5_5?: Text
                payouts_L5_4?: Text
                payouts_L5_3?: Text
                positions: {};
            };
            page_3: {
                pip?: Sprite
                W?: Sprite
                wild_lining?: Sprite
                S?: Sprite
                scatter_lining?: Sprite
                QH?: Sprite
                qh_lining?: Sprite
                C?: Sprite
                c_lining?: Sprite
                title?: Text
                title_2?: Text
                wild_text?: Text
                scatter_text?: Text
                qh_text?: Text
                c_text?: Text
                positions: {};
            };
            page_4: {
                pip?: Sprite
                mini?: Sprite
                minor?: Sprite
                major?: Sprite
                grand?: Sprite
                title?: Text
                money_collect_feature?: Text
                win_up_to?: Text
                multipliers?: Text
                multipliers_2?: Text
                mini_value?: Text
                minor_value?: Text
                major_value?: Text
                grand_value?: Text
                positions: {};
            };
            page_5: {
                pip?: Sprite
                paylines?: Sprite
                title?: Text
                positions: {};
            };
        };
    };
    public PaytableCommon: Layers & {
        elements: {
            paytable: {
                close?: ButtonElement
                previous?: ButtonElement
                next?: ButtonElement
                page_indicators?: Sprite
                frame?: Sprite
                positions: {};
            };
            active: {
                positions: {};
                close?: ButtonElement
                previous?: ButtonElement
                next?: ButtonElement
                page_indicators?: Sprite
                frame?: Sprite
            };
        };
    };
    public PaytableButton: Layers & {
        elements: {
            base: {
                paytable?: ButtonElement
                positions: {};
            };
            active: {
                positions: {};
                paytable?: ButtonElement
            };
        };
    };
    public Menus: Layers & {
        elements: {
            preloader: {
                gati_logo?: Sprite
                powered_by?: Sprite
                ygg_logo?: Sprite
                loader_bar_mask?: Sprite
                loader_bar?: Sprite
                loader_bar_bg?: Sprite
                ukgc_logo?: Sprite
                btm_shape?: SmartShape
                logo_2lines?: Sprite
                loader_text_alt?: Text
                loader_text?: Text
                jurisdiction_message?: Text
                positions: {};
            };
            active: {
                positions: {};
                gati_logo?: Sprite
                powered_by?: Sprite
                ygg_logo?: Sprite
                loader_bar_mask?: Sprite
                loader_bar?: Sprite
                loader_bar_bg?: Sprite
                ukgc_logo?: Sprite
                btm_shape?: SmartShape
                logo_2lines?: Sprite
                loader_text_alt?: Text
                loader_text?: Text
                jurisdiction_message?: Text
                continue?: ButtonElement
                checkbox?: ToggleElement
                onboard?: AnimatedSprite
                logo_char?: Sprite
                dont_show_next_time?: Text
            };
            bet_screen: {
                gati_logo?: Sprite
                powered_by?: Sprite
                ygg_logo?: Sprite
                continue?: ButtonElement
                checkbox?: ToggleElement
                onboard?: AnimatedSprite
                ukgc_logo?: Sprite
                btm_shape?: SmartShape
                logo_char?: Sprite
                dont_show_next_time?: Text
                jurisdiction_message?: Text
                positions: {};
            };
        };
    };
    public Prompts: Layers & {
        elements: {
            default: {
                positions: {};
            };
            active: {
                positions: {};
                popup?: Sprite
                congratulations?: Text
                you_win?: Text
                value?: Text
                freespins?: Text
                click_tap_play?: Text
            };
            freespinswin: {
                popup?: Sprite
                congratulations?: Text
                you_win?: Text
                value?: Text
                freespins?: Text
                click_tap_play?: Text
                positions: {};
            };
            freespinssummary: {
                popup?: Sprite
                congratulations?: Text
                you_win?: Text
                value?: Text
                click_tap_play?: Text
                positions: {};
            };
        };
    };
    public MenuContent: Layers & {
        elements: {
            autoplay: {
                close?: ButtonElement
                autoplay_radio_right?: ButtonElement
                autoplay_radio_left?: ButtonElement
                single_win_limit_radio_right?: ButtonElement
                single_win_limit_radio_left?: ButtonElement
                loss_limit_radio_right?: ButtonElement
                loss_limit_radio_left?: ButtonElement
                autoplay_radio_1?: ButtonElement
                autoplay_radio_2?: ButtonElement
                autoplay_radio_3?: ButtonElement
                autoplay_radio_4?: ButtonElement
                autoplay_radio_5?: ButtonElement
                loss_limit_radio_1?: ButtonElement
                loss_limit_radio_2?: ButtonElement
                loss_limit_radio_3?: ButtonElement
                loss_limit_radio_4?: ButtonElement
                loss_limit_radio_5?: ButtonElement
                single_win_limit_radio_1?: ButtonElement
                single_win_limit_radio_2?: ButtonElement
                single_win_limit_radio_3?: ButtonElement
                single_win_limit_radio_4?: ButtonElement
                single_win_limit_radio_5?: ButtonElement
                autoplay_start_button?: ButtonElement
                stop_on_feature?: ToggleElement
                autoplay_background?: Sprite
                cover?: SmartShape
                autoplay_title_label?: Text
                number_of_autoplays?: Text
                loss_limit_label?: Text
                single_win_limit_label?: Text
                autoplay_radio_1_label?: Text
                autoplay_radio_2_label?: Text
                autoplay_radio_3_label?: Text
                autoplay_radio_4_label?: Text
                autoplay_radio_5_label?: Text
                loss_limit_radio_1_label?: Text
                loss_limit_radio_2_label?: Text
                loss_limit_radio_3_label?: Text
                loss_limit_radio_4_label?: Text
                loss_limit_radio_5_label?: Text
                single_win_limit_radio_1_label?: Text
                single_win_limit_radio_2_label?: Text
                single_win_limit_radio_3_label?: Text
                single_win_limit_radio_4_label?: Text
                single_win_limit_radio_5_label?: Text
                stop_on_feature_label?: Text
                positions: {};
            };
            active: {
                positions: {};
                close?: ButtonElement
                autoplay_radio_right?: ButtonElement
                autoplay_radio_left?: ButtonElement
                single_win_limit_radio_right?: ButtonElement
                single_win_limit_radio_left?: ButtonElement
                loss_limit_radio_right?: ButtonElement
                loss_limit_radio_left?: ButtonElement
                autoplay_radio_1?: ButtonElement
                autoplay_radio_2?: ButtonElement
                autoplay_radio_3?: ButtonElement
                autoplay_radio_4?: ButtonElement
                autoplay_radio_5?: ButtonElement
                loss_limit_radio_1?: ButtonElement
                loss_limit_radio_2?: ButtonElement
                loss_limit_radio_3?: ButtonElement
                loss_limit_radio_4?: ButtonElement
                loss_limit_radio_5?: ButtonElement
                single_win_limit_radio_1?: ButtonElement
                single_win_limit_radio_2?: ButtonElement
                single_win_limit_radio_3?: ButtonElement
                single_win_limit_radio_4?: ButtonElement
                single_win_limit_radio_5?: ButtonElement
                autoplay_start_button?: ButtonElement
                stop_on_feature?: ToggleElement
                autoplay_background?: Sprite
                cover?: SmartShape
                autoplay_title_label?: Text
                number_of_autoplays?: Text
                loss_limit_label?: Text
                single_win_limit_label?: Text
                autoplay_radio_1_label?: Text
                autoplay_radio_2_label?: Text
                autoplay_radio_3_label?: Text
                autoplay_radio_4_label?: Text
                autoplay_radio_5_label?: Text
                loss_limit_radio_1_label?: Text
                loss_limit_radio_2_label?: Text
                loss_limit_radio_3_label?: Text
                loss_limit_radio_4_label?: Text
                loss_limit_radio_5_label?: Text
                single_win_limit_radio_1_label?: Text
                single_win_limit_radio_2_label?: Text
                single_win_limit_radio_3_label?: Text
                single_win_limit_radio_4_label?: Text
                single_win_limit_radio_5_label?: Text
                stop_on_feature_label?: Text
                history?: ButtonElement
                home?: ButtonElement
                bg_landscape?: Sprite
                bg_portrait?: Sprite
            };
            rules_minimal: {
                history?: ButtonElement
                home?: ButtonElement
                bg_landscape?: Sprite
                cover?: SmartShape
                bg_portrait?: Sprite
                positions: {};
            };
            rules: {
                history?: ButtonElement
                home?: ButtonElement
                close?: ButtonElement
                bg_landscape?: Sprite
                cover?: SmartShape
                bg_portrait?: Sprite
                positions: {};
            };
        };
    };
    public Freegames: Layers & {
        elements: {
            base: {
                background?: Sprite
                gamevy_free_games_label?: Text
                gamevy_free_games_count_label?: Text
                gamevy_free_games_total_label?: Text
                positions: {};
            };
            active: {
                positions: {};
                background?: Sprite
                gamevy_free_games_label?: Text
                gamevy_free_games_count_label?: Text
                gamevy_free_games_total_label?: Text
            };
        };
    };
    public Jurisdiction: Layers & {
        elements: {
            base: {
                juri_background?: Sprite
                line_1?: Text
                line_2?: Text
                line_3?: Text
                line_4?: Text
                positions: {};
            };
            active: {
                positions: {};
                juri_background?: Sprite
                line_1?: Text
                line_2?: Text
                line_3?: Text
                line_4?: Text
            };
        };
    };
    public Header: Layers & {
        elements: {
            header: {
                time_bg?: Sprite
                name_bg?: Sprite
                game_name?: Text
                spin_id?: Text
                ukgc_elapsed_time?: Text
                ukgc_clock?: Text
                clock?: Text
                positions: {};
            };
            active: {
                positions: {};
                time_bg?: Sprite
                name_bg?: Sprite
                game_name?: Text
                spin_id?: Text
                ukgc_elapsed_time?: Text
                ukgc_clock?: Text
                clock?: Text
            };
        };
    };
    public SmartButton: Layers & {
        elements: {
            minimal: {
                skipArea?: SmartShape
                positions: {};
            };
            active: {
                positions: {};
                skipArea?: SmartShape
                spin?: ButtonElement
            };
            auto: {
                spin?: ButtonElement
                positions: {};
            };
            spin: {
                spin?: ButtonElement
                positions: {};
            };
            freespins: {
                spin?: ButtonElement
                positions: {};
            };
        };
    };
    public Autoplay: Layers & {
        elements: {
            minimal: {
                positions: {};
            };
            active: {
                positions: {};
                ui_autoplay?: ToggleElement
                autoplay_stop_button?: ButtonElement
                autoplay_count?: Text
            };
            freespins: {
                positions: {};
            };
            spin: {
                ui_autoplay?: ToggleElement
                positions: {};
            };
            auto: {
                autoplay_stop_button?: ButtonElement
                autoplay_count?: Text
                positions: {};
            };
        };
    };
    public Turbo: Layers & {
        elements: {
            minimal: {
                positions: {};
            };
            active: {
                positions: {};
                turbo_toggle?: ToggleElement
            };
            auto: {
                turbo_toggle?: ToggleElement
                positions: {};
            };
            spin: {
                turbo_toggle?: ToggleElement
                positions: {};
            };
            freespins: {
                turbo_toggle?: ToggleElement
                positions: {};
            };
        };
    };
    public Skip: Layers & {
        elements: {
            skip: {
                positions: {};
            };
            active: {
                positions: {};
            };
        };
    };
    public BetBar: Layers & {
        elements: {
            base: {
                sound_toggle_loading?: Sprite
                ui_paytable?: ToggleElement
                ui_settings?: ToggleElement
                sound_toggle_on?: ButtonElement
                sound_toggle_off?: ButtonElement
                portrait_stake_up?: ButtonElement
                portrait_stake_down?: ButtonElement
                net_position_icon?: Sprite
                portrait_bg?: Sprite
                stake_down?: ButtonElement
                stake_up?: ButtonElement
                line?: Sprite
                stake_bg?: Sprite
                betbar_background?: Sprite
                net_position_value?: Text
                stake_value?: Text
                stake_label?: Text
                balance_value?: Text
                balance_label?: Text
                total_win_value?: Text
                positions: {};
            };
            active: {
                positions: {};
                sound_toggle_loading?: Sprite
                ui_paytable?: ToggleElement
                ui_settings?: ToggleElement
                sound_toggle_on?: ButtonElement
                sound_toggle_off?: ButtonElement
                portrait_stake_up?: ButtonElement
                portrait_stake_down?: ButtonElement
                net_position_icon?: Sprite
                portrait_bg?: Sprite
                stake_down?: ButtonElement
                stake_up?: ButtonElement
                line?: Sprite
                stake_bg?: Sprite
                betbar_background?: Sprite
                net_position_value?: Text
                stake_value?: Text
                stake_label?: Text
                balance_value?: Text
                balance_label?: Text
                total_win_value?: Text
                line2?: Sprite
                bg?: Sprite
                freespins_x_of_y_value?: Text
                freespins_label?: Text
                total_stake?: Text
                bg_port_left?: Sprite
                bg_port_right?: Sprite
                bg_left?: Sprite
                bg_right?: Sprite
            };
            freespins: {
                net_position_icon?: Sprite
                sound_toggle_loading?: Sprite
                sound_toggle_on?: ButtonElement
                sound_toggle_off?: ButtonElement
                ui_paytable?: ToggleElement
                ui_settings?: ToggleElement
                portrait_bg?: Sprite
                stake_down?: ButtonElement
                stake_up?: ButtonElement
                stake_bg?: Sprite
                line2?: Sprite
                line?: Sprite
                bg?: Sprite
                net_position_value?: Text
                freespins_x_of_y_value?: Text
                freespins_label?: Text
                total_stake?: Text
                stake_label?: Text
                total_win_value?: Text
                balance_value?: Text
                balance_label?: Text
                positions: {};
            };
            minimal: {
                net_position_icon?: Sprite
                bg_port_left?: Sprite
                bg_port_right?: Sprite
                bg_left?: Sprite
                bg_right?: Sprite
                net_position_value?: Text
                balance_value?: Text
                balance_label?: Text
                total_stake?: Text
                stake_label?: Text
                positions: {};
            };
        };
    };
}

export enum LayerNames {
    CelebrationForeground = "CelebrationForeground",
    CelebrationContent = "CelebrationContent",
    CelebrationBackground = "CelebrationBackground",
    Templates = "Templates",
    JackpotValues = "JackpotValues",
    TigerHeader = "TigerHeader",
    InstantWins = "InstantWins",
    Paylines = "Paylines",
    Footer = "Footer",
    Anticipation = "Anticipation",
    MatrixForeground = "MatrixForeground",
    ReelDust = "ReelDust",
    FreespinsIntro = "FreespinsIntro",
    SymbolAnimations = "SymbolAnimations",
    MatrixContent = "MatrixContent",
    MatrixBackground = "MatrixBackground",
    Background = "Background",
    History = "History",
    PaytableContent = "PaytableContent",
    PaytableCommon = "PaytableCommon",
    PaytableButton = "PaytableButton",
    Menus = "Menus",
    Prompts = "Prompts",
    MenuContent = "MenuContent",
    Freegames = "Freegames",
    Jurisdiction = "Jurisdiction",
    Header = "Header",
    SmartButton = "SmartButton",
    Autoplay = "Autoplay",
    Turbo = "Turbo",
    Skip = "Skip",
    BetBar = "BetBar"
}

export const gameLayers = new GameLayers();
export const assetworksData = {gameLayers, LayerNames, SoundNames};
